import { useTracking } from 'react-tracking';
import Media from 'react-media';
import type { ShareholderWithTitle } from '@/pages/CompanyReport/components/Ownership';
import {
  TopShareholdersTable,
  TopShareholdersAccordion,
} from '@/pages/CompanyReport/components/Ownership';
import { useTheme } from '@simplywallst/ui-core';
import { ShareholdersWrapper } from './styled';
import { ViewMode } from '@/pages/CompanyReport/enum';

export interface TopShareholdersProps {
  topShareholders: ShareholderWithTitle[];
  viewMode: ViewMode;
}

const TopShareholders = ({
  topShareholders,
  viewMode,
}: TopShareholdersProps) => {
  const theme = useTheme();
  const { Track } = useTracking({
    type: 'track',
    subject: 'topShareholders',
    listLength: topShareholders.length,
  });
  return (
    <Track>
      <ShareholdersWrapper>
        <Media query={{ minWidth: theme.mdMinRaw }}>
          {(matches) =>
            matches || viewMode === ViewMode.Print ? (
              <TopShareholdersTable topShareholders={topShareholders} />
            ) : (
              <TopShareholdersAccordion topShareholders={topShareholders} />
            )
          }
        </Media>
      </ShareholdersWrapper>
    </Track>
  );
};

export default TopShareholders;
